import { IResultMetadata } from 'dromo-uploader-react'
import { ImportUtilityModel } from '../AddImportUtilityDrawer/typings'
import { importSetup } from '../helpers/importSetup'
import { UseData } from './useData'
import { useCallback } from 'react'
import { toast } from '@sales-center/components'
import { SaveResults } from '../helpers/saveResults'
import { isProduction } from '@sales-center/common'

type Props = Pick<
  UseData,
  | 'setUploadId'
  | 'setShowDromo'
  | 'setImportDefaultValues'
  | 'setShowConfirmPopup'
  | 'importDefaultValues'
>

export function useHandlers(props: Props) {
  const {
    setUploadId,
    setShowDromo,
    setImportDefaultValues,
    setShowConfirmPopup,
    importDefaultValues,
  } = props

  const onResults = useCallback(
    async (_data, metadata: IResultMetadata) => {
      setUploadId(metadata.id)
      setShowConfirmPopup(true)

      if (!isProduction) {
        console.log(`DromoId (data.id): ${metadata.id}`)
        console.log(
          `TempApiKey (data.user.company_id): ${importDefaultValues?.tempApiKey}`,
        )
      }

      await SaveResults(importDefaultValues?.tempApiKey, metadata)
    },
    [setUploadId, setShowConfirmPopup, importDefaultValues?.tempApiKey],
  )

  async function onDrawerSave(importDefaultValues: ImportUtilityModel) {
    const tempApiKey = await importSetup({
      name: importDefaultValues.name,
      description: importDefaultValues.description || '',
      entityType: importDefaultValues.entityType,
    })

    if (tempApiKey === null) {
      toast.error('Could not save import settings')
    } else {
      setShowDromo(true)
      setImportDefaultValues({ ...importDefaultValues, tempApiKey })
    }
  }

  function onResetButtonClick() {
    setUploadId(null)
    setShowDromo(false)
  }

  function onCancelDromo() {
    setUploadId(null)
    setShowDromo(false)
  }

  const cancelClick = useCallback(() => {
    setShowConfirmPopup(false)
    setShowDromo(false)
  }, [setShowConfirmPopup, setShowDromo])

  return {
    onResults,
    onDrawerSave,
    onCancelDromo,
    onResetButtonClick,
    cancelClick,
  }
}
